import { v1ApiClient } from '@/services';

type VerifySharedLinkParams = { link: string; sign: string };
type VerifySharedLinkResponse = Record<string, never>;
type VerifySharedLinkFunction = (
  params: VerifySharedLinkParams,
) => Promise<VerifySharedLinkResponse>;

export const verifySharedLink: VerifySharedLinkFunction = (params) =>
  v1ApiClient.post('/shared-link/verify', params).then((res) => res.data);
